interface CreditCard {
  cardNumber?: string;
  securityCode?: string;
  year?: string;
  month?: string;
}

export interface StripeResponse {
  error?: stripe.StripeError;
  token?: string;
}

export const callStripeApi = (
  creditCard: CreditCard,
): Promise<StripeResponse> => {
  return new Promise(resolve => {
    Stripe.createToken(
      {
        cvc: creditCard.securityCode,
        exp_month: parseInt(creditCard.month!, 10),
        exp_year: parseInt(creditCard.year!, 10),
        number: creditCard.cardNumber!,
      },
      (status, response) => {
        if (status === 200) {
          resolve({ token: response.id });
        } else {
          resolve({ error: response.error });
        }
      },
    );
  });
};
